import Header from '../components/header'

export default function About(){
    return (
        <>
        <Header/>
        <h2>Contact Page</h2>
        </>
    )
}